var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserGuide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 0V2H1V3H2V6H1V7H2V10H1V11H2V14H13V0H2ZM12 13H3V11H4V10H3V7H4V6H3V3H4V2H3V1H12V13ZM15 2V16H3V15H14V2H15ZM7.75 3.5C8.44 3.5 9 4.06 9 4.75C9 5.44 8.44 6 7.75 6C7.06 6 6.5 5.44 6.5 4.75C6.5 4.06 7.06 3.5 7.75 3.5ZM9 7.84V11H7V8H6V7H8.16C8.62 7 8.99 7.38 9 7.84Z",
    fill: "#1F1F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserGuide);
export default __webpack_public_path__ + "static/media/user_guide.0ee75ed09f63e64c987515a91afae177.svg";
export { ForwardRef as ReactComponent };